"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SEPARATOR = exports.PREFIX = void 0;
exports.PREFIX = 'APP';
exports.SEPARATOR = '::';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@shopify/app-bridge-core/actions/constants.js
// module id = 95s0
// module chunks = 0